<script lang="ts">
import 'trix';
import { createEventDispatcher, onMount } from 'svelte';

export let value: string | number = '';
let curValue: string;
let trix: any;
const dispatch = createEventDispatcher();

$: setValue(value);

onMount(() => {
    setValue(value);
});

function handleChange(evt: Event) {
    value = curValue = trix.innerHTML;
    dispatch('input');
}

function setValue(value: string | number) {
    if (trix && value !== curValue) {
        trix.editor.loadHTML(String(value));
    }
}
</script>
<style lang="scss">
trix-editor {
    min-height: 100px;
    max-height: 300px;
    overflow: auto;
    background: #FFFFFF;
    border: 1px solid #e5e7e8;
    color: #333;
    padding: 15px 12px;
    width: 100%;
    box-sizing: border-box;
}
</style>
<trix-editor class="trix-content"
    bind:this={trix}
    on:trix-change={handleChange}></trix-editor>
